import { getDB } from './schema';
import type { MediaRow } from '../types/content';

// Binary media stored as Blobs, keyed by file name. Replaces the on-disk
// content directory used by the Android downloader.

export const mediaRepo = {
  async get(name: string): Promise<MediaRow | undefined> {
    if (!name) return undefined;
    const db = await getDB();
    return db.get('media', name);
  },

  // True if a blob with the exact expected size already exists (skip download).
  // Checks the actual blob size, not just the recorded metadata: an unclean
  // power-off can truncate/corrupt the stored blob while the row survives.
  async hasExact(name: string, size: number): Promise<boolean> {
    const row = await this.get(name);
    return !!row && row.size === size && row.blob.size === size;
  },

  async put(row: MediaRow): Promise<void> {
    const db = await getDB();
    await db.put('media', row);
  },

  async delete(name: string): Promise<void> {
    if (!name) return;
    const db = await getDB();
    await db.delete('media', name);
  },

  async objectUrl(name: string): Promise<string | null> {
    const row = await this.get(name);
    if (!row) return null;
    return URL.createObjectURL(row.blob);
  },
};
